import React from 'react';
// Prefer public assets to allow preload via index.html
const heroAvif = '/hero/hero-bg.avif';
const heroWebp = '/hero/hero-bg.webp';
const heroJpg = '/hero/hero-bg.jpg';

const Hero = () => (
  <section className="hero" style={{
      backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.35), rgba(0,0,0,0.45)), url(${heroAvif}), url(${heroWebp}), url(${heroJpg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
    <div className="container hero-inner">
      <span className="pill">Locally owned · Melbourne’s West</span>
      <h1>Lawns Out West – Professional Lawn & Garden Services Across Melbourne’s West</h1>
      <p>Let Us Transform Your Lawn & Garden. Free Quotes, Top Service, Satisfaction Guaranteed.</p>
      <a href="#contact" className="btn">Get a Free Quote</a>
    </div>
  </section>
);

export default Hero;


